<template>
  <div v-loading="pLoading" class="deviceConfig">
    <el-card shadow="never">{{ projectName }}</el-card>
    <div class="content" @click="getMouseXY($event)">
      <el-form ref="form" :inline="true">
        <el-form-item>
          <el-button type="primary" @click="addEms()">添加EMS</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload class="upload-demo" ref="uploadEms" action="" :before-upload="beforeUploadEms" accept=".xls, .xlsx"
            :file-list="emsFileList">
            <el-button slot="trigger" type="primary">导入EMS(excel)</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button v-if="isBatchDeleteBtn" type="danger" size="small" @click="batchDelete()">批量删除</el-button>
        </el-form-item>
      </el-form>
      <div class="leftTree">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        <el-tree class="filter-tree" :data="treeData" :props="defaultProps" node-key="id"
          :default-expand-all="defaultExpandAll" :key="treeKey" highlight-current :expand-on-click-node="false"
          :filter-node-method="filterNode" ref="tree" @node-click="handleNodeClick">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span v-if="node.label.length<25">{{ node.label }}</span>
            <el-tooltip v-else effect="light" :content="node.label" :open-delay="500" placement="top">
              <span>{{ node.label }}</span>
            </el-tooltip>
            <!-- <span>
            <el-button v-show="!data.show" class="btn" type="text" size="mini" @click="handle(data)">操作</el-button>
            <el-button v-show="data.show" class="btn" type="text" size="mini" @click="complete(data)" style="color: #67C23A;font-weight: bold;margin-left: 20px !important;">完成</el-button>
            <span v-show="data.show">
              <el-button class="btn" type="text" size="mini" @click="() => append()">
                +
              </el-button>
              <el-button v-if="data.type == 2" class="btn" type="text" size="mini" @click="() => choose(data)">
                选择
              </el-button>
              <el-button v-if="data.type == 2" class="btn" type="text" size="mini" @click="() => remove()">
                -
              </el-button>
              <el-button v-if="data.type == 2" class="btn" type="text" size="mini" @click="edit()">
                修改
              </el-button>
              <el-button v-if="data.type == 2" class="btn" type="text" size="mini" @click="() => copy(data)">
                复制
              </el-button>
              <el-button class="btn" type="text" size="mini" @click="() => leadingIn(node, data)">
                导入
              </el-button>
              <el-button v-if="data.type == 2" class="btn" type="text" size="mini" @click="() => addDataPoint()">
                添加数据点
              </el-button>
            </span>
          </span> -->
            <span>
              <el-tooltip content="新增" :disabled="disabled" :open-delay="500" placement="top" effect="light">
                <img src="../../../../static/images/boss/append.png" alt="" @click="() => append(data)"
                  style="width: 12px;">
              </el-tooltip>
              <el-tooltip content="选择" :disabled="disabled" :open-delay="500" placement="top" effect="light">
                <img v-if="data.type == 1" src="../../../../static/images/boss/choose.png" alt=""
                  @click="() => choose(data)" style="width: 12px;">
              </el-tooltip>
              <el-tooltip content="编辑" :disabled="disabled" :open-delay="500" placement="top" effect="light">
                <img v-if="data.type == 1" src="../../../../static/images/boss/edit.png" alt=""
                  @click="() => editEms(data)" style="width: 12px;">
              </el-tooltip>
              <el-tooltip content="添加数据点" :disabled="disabled" :open-delay="500" placement="top" effect="light">
                <img v-if="data.type == 2" src="../../../../static/images/boss/addDataPoint.png" alt=""
                  @click="() => addDataPoint()" style="width: 12px;">
              </el-tooltip>
              <span v-if="data.type == 2" id="sector">
                <span class="moreIcon">
                  <!-- <el-tooltip content="更多" :open-delay="500" placement="top" effect="light"> -->
                  <img src="../../../../static/images/boss/more.png" alt="" @click="() => more(data)"
                    style="width: 12px;">
                  <!-- </el-tooltip> -->
                </span>
                <ul v-show="data.show">
                  <el-tooltip content="新增" :open-delay="500" placement="top" effect="light">
                    <li class="sector1" @click="() => append(data)">
                      <img src="../../../../static/images/boss/append.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="添加数据点" :open-delay="500" placement="top" effect="light">
                    <li class="sector2" @click="() => addDataPoint()">
                      <img src="../../../../static/images/boss/addDataPoint.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="编辑" :open-delay="500" placement="top" effect="light">
                    <li class="sector3" @click="() => edit()">
                      <img src="../../../../static/images/boss/edit.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="选择" :open-delay="500" placement="top" effect="light">
                    <li class="sector4" @click="choose(data)">
                      <img src="../../../../static/images/boss/choose.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="复制" :open-delay="500" placement="top" effect="light">
                    <li class="sector5" @click="() => copy(data)">
                      <img src="../../../../static/images/boss/copy.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="导入" :open-delay="500" placement="top" effect="light">
                    <li class="sector6" @click="() => leadingIn(node, data)">
                      <img src="../../../../static/images/boss/import.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                  <el-tooltip content="删除" :open-delay="500" placement="top" effect="light">
                    <li class="sector7" @click="() => remove(node, data)">
                      <img src="../../../../static/images/boss/delete.png" alt="" style="width: 12px;">
                    </li>
                  </el-tooltip>
                </ul>
              </span>
            </span>
            <div v-if="data.isCopyBlock" class="copyBlock">
              <el-input v-model="copyDeviceCode" placeholder="名称" size="mini" style="width: 160px;"></el-input>
              <el-button type="primary" size="mini" style="margin-left: 5px;"
                @click="copyProjectEquipment()">确定</el-button>
            </div>
          </span>
        </el-tree>
      </div>
      <div class="rightTable">
        <el-table ref="dataPointTable" :data="tableData" border highlight-current-row height="56vh"
          @selection-change="handleSelectionChange" style="width: 100%;">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="content" label="名称" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-html="row.content"></span>
            </template>
          </el-table-column>
          <el-table-column prop="fields" label="标识" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-html="row.fields"></span>
            </template>
          </el-table-column>
          <el-table-column prop="fieldsId" label="编号" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-html="row.fieldsId"></span>
            </template>
          </el-table-column>
          <el-table-column prop="dataType" label="数据类型">
            <template slot-scope="{ row }">
              <span v-html="row.dataType"></span>
            </template>
          </el-table-column>
          <el-table-column prop="dataTypeId" label="点类型">
            <template slot-scope="{ row }">
              <span v-html="row.dataTypeId"></span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="defaultValue" label="默认值" width="80" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.defaultValue"></span>
          </template>
        </el-table-column> -->
          <!-- <el-table-column prop="coefficient" label="系数" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.coefficient"></span>
          </template>
        </el-table-column> -->
          <el-table-column prop="authorization" label="权限" width="60">
            <template slot-scope="{ row }">
              {{ row.authorization == 0 ? "只读" : row.authorization == 1 ? "只写" : "读写" }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="165">
            <template slot-scope="{ row }">
              <span v-html="row.createTime"></span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="165">
            <template slot-scope="{ row }">
              <span v-html="row.updateTime"></span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="fieldDescribe" label="描述" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.fieldDescribe"></span>
          </template>
        </el-table-column> -->
          <!-- <el-table-column prop="range" label="数值范围" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.range"></span>
          </template>
        </el-table-column> -->
          <el-table-column prop="unit" label="单位" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-html="row.unit"></span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="{ row }">
              <el-button class="btn" type="text" size="small" @click="onEdit(row)">修改</el-button>
              <el-button class="btn" type="text" size="small" @click="onDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- EMS配置 -->
    <Dialog ref="emsConfigDialog" title="EMS配置">
      <el-form ref="emsConfigForm" :rules="emsConfigRules" :model="emsConfigForm" label-width="100px">
        <el-form-item label="EMS名称:" prop="emsName">
          <el-input v-model="emsConfigForm.emsName" placeholder="EMS名称" style="width: 80%;" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="SN号:" prop="sn">
          <el-input v-model="emsConfigForm.sn" placeholder="SN号" :readonly="!isAddEms" style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="储能仓名称:" prop="cabinName">
          <el-input v-model="emsConfigForm.cabinName" placeholder="储能仓名称" style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="EMS类型:" prop="emsType">
          <el-select v-model="emsConfigForm.emsType" placeholder="请选择ems类型" style="width: 80%;">
            <el-option v-for="item in emsTypeOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitProjectEms('emsConfigForm')"
            style="margin-left: 36%;transform: translateX(-50%);">保存</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
    <!-- 设备配置 -->
    <Dialog ref="deviceConfigDialog" title="设备配置">
      <el-form ref="deviceConfigForm" :rules="deviceConfigRules" :model="deviceConfigForm" label-width="130px">
        <el-form-item label="设备标识:" prop="code" required>
          <el-input v-model="deviceConfigForm.code" placeholder="设备标识" style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="设备名称:" prop="content" required>
          <el-input v-model="deviceConfigForm.content" placeholder="设备名称" style="width: 80%;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="完整设备前缀编号:">
        <el-input v-model="deviceConfigForm.fullPrefixCode" placeholder="完整设备前缀编号" style="width: 80%;"></el-input>
      </el-form-item> -->
        <el-form-item label="类型:" prop="topType" required>
          <el-select v-model="deviceConfigForm.topType" clearable placeholder="类型" style="width: 60%;"
            @change="searchProductList(deviceConfigForm.topType)">
            <el-option v-for="(item, index) in levelTypeList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="deviceTypeList.length>0" label="设备类型:" prop="type">
          <el-select v-model="deviceConfigForm.type" clearable placeholder="设备类型" @change="pickChange"
            style="width: 60%;">
            <el-option v-for="(item, index) in deviceTypeList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="厂商:" prop="manufacturersId">
          <el-select v-model="deviceConfigForm.manufacturersId" clearable placeholder="厂商" style="width: 60%;">
            <el-option v-for="(item, index) in manufacturersList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="设备类型:">
        <el-select v-model="deviceConfigForm.type" clearable placeholder="设备类型" style="width: 60%;">
          <el-option v-for="(item, index) in deviceTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="saveProjectEquipmentInfo('deviceConfigForm')"
            style="margin-left: 36%;transform: translateX(-50%);">保存</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
    <!-- 层级选择 -->
    <Dialog ref="chooseDataDialog" title="层级选择" dlgWidth="60%">
      <el-form ref="chooseDataForm" :inline="true" :model="chooseDialogData">
        <el-form-item label="层级类型:">
          <el-select v-model="chooseDialogData.topProductTypeId" clearable placeholder="层级类型"
            @change="searchProductList(chooseDialogData.topProductTypeId)">
            <el-option v-for="(item, index) in levelTypeList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品类型:">
          <el-select v-model="chooseDialogData.productType" clearable placeholder="产品类型" @change="pickChange">
            <el-option v-for="(item, index) in productTypeList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字:">
          <el-input v-model="chooseDialogData.searchKey" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onChooseSearch()">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="multipleTable" :data="levelTableData" height="300" @selection-change="onSelectionChange"
        @select="handleSelectionRows" style="width: 100%;">
        <el-table-column type="selection" width="50">
        </el-table-column>
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="topProductTypeName" label="层级类型">
          <template slot-scope="{ row }">
            <span v-html="row.topProductTypeName"></span>
          </template>
        </el-table-column>
        <el-table-column prop="productTypeName" label="产品类型">
          <template slot-scope="{ row }">
            <span v-html="row.productTypeName"></span>
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" label="名称">
          <template slot-scope="{ row }">
            <span v-html="row.deviceName"></span>
          </template>
        </el-table-column>
        <el-table-column prop="deviceCode" label="标识">
          <template slot-scope="{ row }">
            <span v-html="row.deviceCode"></span>
          </template>
        </el-table-column>
        <el-table-column prop="parentName" label="上级设备名称">
          <template slot-scope="{ row }">
            <span v-html="row.parentName"></span>
          </template>
        </el-table-column>
        <el-table-column prop="parentDeviceCode" label="上级设备标识">
          <template slot-scope="{ row }">
            <span v-html="row.parentDeviceCode"></span>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" @click="saveEquipmentLibraryChoose()"
        style="margin-top: 20px;margin-left: 50%;transform: translateX(-50%);">确定</el-button>
    </Dialog>
    <!-- 数据点配置 -->
    <Dialog ref="dataPointConfigDialog" title="数据点配置">
      <el-form ref="dataPointConfigForm" :rules="dataPointConfigRules" :model="dataPointConfigForm" label-width="120px">
        <el-form-item label="数据点名称:" prop="content" required>
          <el-input v-model="dataPointConfigForm.content" placeholder="请输入数据点名称" style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="数据点标识:" prop="fields" required>
          <el-input v-model="dataPointConfigForm.fields" placeholder="请输入数据点标识" style="width: 80%;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="数据点编号:" prop="fieldsId">
        <el-input v-model="dataPointConfigForm.fieldsId" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
        <el-form-item label="数据类别:" prop="dataType">
          <el-select v-model="dataPointConfigForm.dataType" clearable placeholder="数据类别">
            <el-option v-for="(item, index) in dataTypeList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据点类型:" prop="dataTypeId">
          <el-select v-model="dataPointConfigForm.dataTypeId" clearable filterable placeholder="数据点类型">
            <el-option v-for="(item, index) in dataTypeIdList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="数据类型:" prop="type">
        <el-select v-model="dataPointConfigForm.type" clearable placeholder="数据类型">
          <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item label="数值类型:" prop="valueType">
          <el-select v-model="dataPointConfigForm.valueType" clearable placeholder="数值类型">
            <el-option v-for="(item, index) in valueTypeList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="默认值:" prop="defaultValue">
        <el-input v-model="dataPointConfigForm.defaultValue" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
        <!-- <el-form-item label="点描述:" prop="fieldDescribe">
        <el-input v-model="dataPointConfigForm.fieldDescribe" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
        <!-- <el-form-item label="系数:" prop="coefficient">
        <el-input v-model="dataPointConfigForm.coefficient" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
        <el-form-item label="权限:" prop="authorization">
          <el-select v-model="dataPointConfigForm.authorization" clearable placeholder="权限">
            <el-option v-for="(item, index) in authorityList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="数值范围:" prop="range">
        <el-input v-model="dataPointConfigForm.range" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
        <el-form-item label="数据点单位:" prop="unit">
          <el-input v-model="dataPointConfigForm.unit" placeholder="请输入" style="width: 80%;"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="confirmDataPointConfigData('dataPointConfigForm')"
        style="margin-top: 20px;margin-left: 50%;transform: translateX(-50%);">确定</el-button>
    </Dialog>
    <!-- 导入 -->
    <Dialog ref="leadingInDialog" title="导入">
      <div class="clearfix">
        <el-upload class="upload-demo" ref="upload" action="" :before-upload="beforeUpload" accept=".xls, .xlsx"
          :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件！</div>
        </el-upload>
      </div>
      <el-button type="primary" @click="closeLeadingInDialog()"
        style="margin-top: 20px;margin-left: 50%;transform: translateX(-50%);">关闭</el-button>
    </Dialog>
  </div>
</template>

<script>
  import Dialog from '@/components/dialog';
  import PROJECTAPI from '@/api/project';
  import VENDORAPI from '@/api/vendorManagement';
  import EquipmentLibraryApi from '@/api/equipmentLibrary';
  export default {
    props: {
      projectName: {
        type: [String, Number]
      },
      projectId: {
        type: [String, Number]
      }
    },
    data() {
      return {
        pLoading: false,
        emsConfigForm: {
          emsName: '',
          projectId: '',
          cabinName: '',
          emsType: '',
          sn: ''
        },
        emsConfigRules: {
          emsName: [{
            required: true,
            message: '请输入EMS名称',
            trigger: 'blur'
          }],
          cabinName: [{
            required: true,
            message: '请输入储能仓名称',
            trigger: 'blur'
          }],
          emsType: [{
            required: true,
            message: '请选择EMS类型',
            trigger: 'change'
          }],
          sn: [{
            required: true,
            message: '请输入sn号',
            trigger: 'blur'
          }]
        },
        loading: false,
        start: 0,
        end: 10,
        pageTotal: 10,
        levelTypeList: [],
        productTypeList: [],
        filterText: '',
        treeData: [],
        defaultProps: {
          children: 'childList',
          label(data) {
            return data.type == 1 ? data.emsSn + " (" + data.emsName + ")" : data.equipCode + " (" + data.equipName +
              ")"
          }
        },
        tableData: [],
        deviceConfigForm: {
          content: '',
          code: '',
          topType: '',
          type: '',
          manufacturersId: '',
          // isExistsBattery: true,
          // isRepairZero: true
        },
        deviceConfigRules: {
          content: [{
            required: true,
            message: '请输入设备名称',
            trigger: 'blur'
          }],
          code: [{
            required: true,
            message: '请输入设备标识',
            trigger: 'blur'
          }],
          topType: [{
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }]
        },
        manufacturersList: [],
        deviceTypeList: [],
        chooseDialogData: {
          topProductTypeId: '',
          productType: '',
          searchKey: ''
        },
        levelTableData: [],
        dataPointConfigForm: {
          content: '',
          fields: '',
          // type: '',
          valueType: '',
          fieldCode: '',
          // defaultValue: '',
          // fieldDescribe: '',
          // coefficient: '',
          authorization: '',
          unit: ''
        },
        dataPointConfigRules: {
          content: [{
            required: true,
            message: '请输入数据点名称',
            trigger: 'blur'
          }],
          fields: [{
            required: true,
            message: '请输入数据点标识',
            trigger: 'blur'
          }],
          dataType: [{
            required: true,
            message: '请选择数据类别',
            trigger: 'change'
          }],
          valueType: [{
            required: true,
            message: '请选择数值类型',
            trigger: 'change'
          }],
          authorization: [{
            required: true,
            message: '请选择权限',
            trigger: 'change'
          }],
          unit: [{
            required: true,
            message: '请输入权限',
            trigger: 'blur'
          }],
        },
        dataTypeList: [{
          id: 0,
          name: '未知'
        }, {
          id: 1,
          name: '遥测'
        }, {
          id: 2,
          name: '遥信'
        }, {
          id: 3,
          name: '遥调'
        }, {
          id: 4,
          name: '遥控'
        }],
        typeList: [{
          id: 1,
          name: '模拟量'
        }, {
          id: 2,
          name: '数字量'
        }, {
          id: 3,
          name: '信号量'
        }],
        valueTypeList: [{
          id: 1,
          name: 'int'
        }, {
          id: 2,
          name: 'float'
        }, {
          id: 3,
          name: 'string'
        }],
        dataTypeIdList: [],
        authorityList: [{
          id: 0,
          name: '只读'
        }, {
          id: 1,
          name: '只写'
        }, {
          id: 2,
          name: '读写'
        }],
        fileList: [],
        isZeroFilling: true,
        currTreeData: {},
        isTableEdit: false,
        isHandle: false,
        isTreeEdit: false,
        filterType: '0',
        options: [],
        keyWord: '',
        searchType: '0',
        copyData: {
          topProductTypeId: null,
          productType: null,
          searchKey: ''
        },
        copyFilterType: '0',
        scrollStart: 0,
        scrollEnd: 10,
        scrollTotal: 0,
        currFieldId: '',
        selectRows: [],
        isBatchDeleteBtn: false,
        bindDeviceLibraryIds: [],
        copyTreeData: {},
        copyDeviceCode: '',
        chooseData: {},
        disabled: false,
        emsFileList: [],
        defaultExpandAll: true,
        treeKey: '',
        isAddEms: true,
        selectionRows: [],
        emsTypeOptions: [{
            label: '柜子ems',
            value: 1
          },
          {
            label: '站级',
            value: 2
          },
          {
            label: '虚拟',
            value: 3
          },
        ]
      };
    },
    components: {
      Dialog
    },
    created() {
      this.searchDataFieldTypes();
      this.onSearch();
      this.searchManufacturerList();
    },
    mounted() {},
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
      // 'deviceConfigForm.isExistsBattery'(val) {
      //   if (!val) {
      //     this.isZeroFilling = false;
      //   } else {
      //     this.isZeroFilling = true;
      //   }
      // },
      'form.searchKey'(val) {
        this.setName(this.treeData);
        // this.$emit('input', val)
      },
      selectRows(val) {
        if (val.length > 0) {
          this.isBatchDeleteBtn = true;
        } else {
          this.isBatchDeleteBtn = false;
        }
      },
      levelTableData(val) {
        this.$nextTick(() => {
          if (this.selectionRows) {
            this.selectionRows.forEach(row => {
              this.$refs.multipleTable.toggleRowSelection(row);
            })
          }
        })
      }
    },
    methods: {
      //新增EMS
      addEms() {
        this.isAddEms = true;
        this.emsConfigForm = {};
        this.$refs.emsConfigDialog.open();
      },
      //添加项目EMS
      submitProjectEms(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.isAddEms) {
              let addParams = this.emsConfigForm;
              addParams.projectId = this.projectId;
              PROJECTAPI.addProjectEmsV2(addParams).then(res => {
                if (res.data.code == 200) {
                  this.$message.success("添加成功！");
                  this.$refs.emsConfigDialog.close();
                  this.onSearch();
                }
              });
            } else {
              if (this.emsConfigForm.emsName.length <= 50) {
                let editParams = {
                  emsId: this.emsConfigForm.emsId,
                  emsName: this.emsConfigForm.emsName,
                  projectId: this.projectId,
                  sn: this.emsConfigForm.emsSn
                };
                PROJECTAPI.updateProjectEms(editParams).then(res => {
                  if (res.data.code == 200) {
                    this.$message.success("修改成功！");
                    this.$refs.emsConfigDialog.close();
                    this.onSearch();
                  }
                });
              } else {
                this.$message.warning("名称长度不能超过50个字！");
              }
            }
          }
        })
      },
      editEms(data) {
        this.isAddEms = false;
        this.emsConfigForm = data;
        this.emsConfigForm.sn = data.emsSn;
        this.$refs.emsConfigDialog.open();
      },
      //产品类型列表
      searchProductList(data) {
        if (!this.isTreeEdit) {
          this.deviceConfigForm.type = "";
        }
        if (data != 3) {
          this.productTypeList = [];
        }
        this.chooseDialogData.productType = "";
        let params = {
          parentId: data
        };
        EquipmentLibraryApi.searchProductList(params).then(res => {
          if (res.data.code == 200) {
            if (data == 0) {
              this.levelTypeList = res.data.data;
            } else if (data == 3) {
              this.productTypeList = res.data.data;
            }
            this.deviceTypeList = res.data.data;
          }
        });
      },
      //层级类型列表
      searchDataFieldTypes() {
        EquipmentLibraryApi.searchDataFieldTypes().then(res => {
          if (res.data.code == 200) {
            this.dataTypeIdList = res.data.data;
          }
        });
      },
      remoteMethod(query) {
        this.keyWord = query;
        this.start = 0;
        this.end = 10;
        this.loading = true;
        if (query != "") {
          try {
            let params = {
              start: this.start,
              productTypeId: this.form.productType,
              searchKey: query,
              end: this.end,
              topProductTypeId: this.form.topProductTypeId,
              type: this.filterType
            };
            EquipmentLibraryApi.searchDeviceLibrary(params).then(res => {
              if (res.data.code == 200) {
                var result = res.data.data.dataList;
                if (result.length > 0) {
                  for (let i in result) {
                    result[i].label = "上级设备：" + result[i].parentDeviceCode + "(" + result[i].parentName + ")，设备：" +
                      result[i].code + "(" + result[i].content + ")，点：" + result[i].fieldCode + "(" + result[i]
                      .fieldName + ")";
                    var el = document.createElement('div');
                    el.innerHTML = result[i].label;
                    el.getElementsByTagName('a'); // Live NodeList of your anchor elements
                    result[i].value = el.innerText;
                    result[i].id = result[i].deviceId + "_" + result[i].fieldId;
                  }
                  this.options = result;
                }
                this.pageTotal = res.data.data.totalCount != 0 ? res.data.data.totalCount : 10;
              }
            });
          } catch (e) {
            // console.log(e)
          } finally {
            this.loading = false;
          }
        }
      },
      searchMore() {
        this.start += 10;
        this.end += 10;
        this.loading = true;
        try {
          let params = {
            start: this.start,
            productTypeId: this.form.productType,
            searchKey: this.keyWord,
            end: this.end,
            topProductTypeId: this.form.topProductTypeId,
            type: this.filterType
          };
          EquipmentLibraryApi.searchDeviceLibrary(params).then(res => {
            if (res.data.code == 200) {
              var result = res.data.data.dataList;
              if (result.length > 0) {
                for (let i in result) {
                  result[i].label = "上级设备：" + result[i].parentDeviceCode + "(" + result[i].parentName + ")，设备：" +
                    result[i].code + "(" + result[i].content + ")，点：" + result[i].fieldCode + "(" + result[i]
                    .fieldName + ")";
                  var ele = document.createElement('div');
                  ele.innerHTML = result[i].label;
                  ele.getElementsByTagName('a'); // Live NodeList of your anchor elements
                  result[i].value = ele.innerText;
                  result[i].id = result[i].deviceId + "_" + result[i].fieldId;
                }
                this.options = this.options.concat(result);
              } else {
                this.$message.warning("已无更多数据！");
              }
            }
          });
        } catch (e) {
          // console.log(e)
        } finally {
          this.loading = false;
        }
      },
      searchDeviceLibrary() {
        let params = {
          start: this.scrollStart,
          productTypeId: this.chooseDialogData.productType,
          searchKey: this.chooseDialogData.searchKey,
          end: this.scrollEnd,
          topProductTypeId: this.chooseDialogData.topProductTypeId,
          type: 0
        };
        EquipmentLibraryApi.searchDeviceLibrary(params).then(res => {
          if (res.data.code == 200) {
            this.levelTableData = this.levelTableData.concat(res.data.data.dataList);
          }
        });
      },
      createStateFilter(queryString) {
        return (state) => {
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      onSearch() {
        let params = {
          projectId: this.projectId
        }
        PROJECTAPI.getProjectEquipmentTree(params).then(res => {
          this.treeKey = "";
          if (res.data.code == 200 && !res.data.errors) {
            if (res.data.data.length > 1) {
              this.defaultExpandAll = false;
            } else {
              this.defaultExpandAll = true;
            }
            this.treeKey = +new Date();
            this.treeData = res.data.data;
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
        this.isHandle = false;
      },
      setName(datas) { //遍历树  获取id数组
        let deviceId = this.form.searchKey.split("_")[0];
        this.currFieldId = this.form.searchKey.split("_")[1];
        for (var i in datas) {
          if (datas[i].id == deviceId) {
            this.$refs.tree.setCurrentKey(datas[i].id);
            let params = {
              id: datas[i].id
            };
            this.searchProjectEquipFields(params);
          }
          if (datas[i].childList) { //存在子节点就递归
            this.setName(datas[i].childList);
          }
        }
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.type == 1 ? data.emsSn.indexOf(value) !== -1 || data.emsName.indexOf(value) !== -1 : data.equipCode
          .indexOf(value) !== -1 || data.equipName.indexOf(value) !== -1;
      },
      handleNodeClick(data) {
        this.pLoading = true;
        if (data.show == undefined) {
          this.$set(data, 'show', false);
        }
        if (!data.show) {
          if (this.moreData) {
            this.$set(this.moreData, 'show', false);
          }
        }
        this.currTreeData = data;
        if (!this.isHandle && data.type == 2) {
          let params = {
            deviceId: data.equipId
          }
          PROJECTAPI.searchProjectEquipFields(params).then(res => {
            if (res.data.code == 200) {
              this.tableData = res.data.data;
              for (let i in this.tableData) {
                for (let j in this.dataTypeIdList) {
                  if (this.tableData[i].dataTypeId == this.dataTypeIdList[j].id) {
                    this.tableData[i].dataTypeId = this.dataTypeIdList[j].name;
                  }
                }
                for (let j in this.dataTypeList) {
                  if (this.tableData[i].dataType == this.dataTypeList[j].id) {
                    this.tableData[i].dataType = this.dataTypeList[j].name;
                  }
                }
              }
            }
            this.pLoading = false;
          });
        } else {
          this.pLoading = false;
        }
      },
      searchProjectEquipFields(data) {
        let params = {
          deviceId: data.equipId
        }
        PROJECTAPI.searchProjectEquipFields(params).then(res => {
          if (res.data.code == 200) {
            this.tableData = res.data.data;
            for (let i in this.tableData) {
              if (this.tableData[i].id == this.currFieldId) {
                this.$refs.dataPointTable.setCurrentRow(this.tableData[i]);
              }
              for (let j in this.dataTypeIdList) {
                if (this.tableData[i].dataTypeId == this.dataTypeIdList[j].id) {
                  this.tableData[i].dataTypeId = this.dataTypeIdList[j].name;
                }
              }
              for (let j in this.dataTypeList) {
                if (this.tableData[i].dataType == this.dataTypeList[j].id) {
                  this.tableData[i].dataType = this.dataTypeList[j].name;
                }
              }
            }
          }
        });
      },
      append() {
        this.searchProductList(0);
        this.isTreeEdit = false;
        this.deviceConfigForm = {};
        this.$refs.deviceConfigDialog.open();
      },
      pickChange() {
        this.$forceUpdate();
      },
      searchManufacturerList() {
        VENDORAPI.searchManufacturerList().then(res => {
          if (res.data.code == 200) {
            this.manufacturersList = res.data.data;
          }
        });
      },
      edit() {
        this.isTreeEdit = true;
        this.$refs.deviceConfigDialog.open();
        this.searchProductList(0);
        this.getProjectEquipmentInfo();
      },
      getProjectEquipmentInfo() {
        let params = {
          deviceId: this.currTreeData.equipId
        };
        PROJECTAPI.getProjectEquipmentInfo(params).then(res => {
          if (res.data.code == 200) {
            this.deviceConfigForm = res.data.data;
            this.deviceConfigForm.manufacturersId = res.data.data.manufacturersId == 0 ? "" : res.data.data
              .manufacturersId;
            this.searchProductList(this.deviceConfigForm.topType);
          }
        });
      },
      //添加/修改项目设备
      saveProjectEquipmentInfo(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.deviceConfigForm.projectId = this.projectId;
            let params = this.deviceConfigForm;
            params.type == "" ? params.type = params.topType : params.type;
            if (!this.isTreeEdit) {
              params.parentId = this.currTreeData.equipId == "" ? 0 : this.currTreeData.equipId;
              params.emsId = this.currTreeData.emsId;
              PROJECTAPI.addProjectEquipmentInfoV2(params).then(res => {
                if (res.data.code == 200) {
                  this.$message.success("添加成功！");
                  this.$refs.deviceConfigDialog.close();
                  this.onSearch();
                }
              });
            } else {
              PROJECTAPI.updateProjectEquipmentInfoV2(params).then(res => {
                if (res.data.code == 200) {
                  this.$message.success("修改成功！");
                  this.$refs.deviceConfigDialog.close();
                  // this.onSearch(true);
                }
              });
            }
          }
        })
      },
      remove(node, data) {
        let self = this;
        this.$confirm('选项中可能存在子选项，删除后将连带子选项一起删除， 确定要执行此操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.deleteProjectEquipmentInfo(node, data);
          })
          .catch(() => {});
      },
      deleteProjectEquipmentInfo(node, data) {
        let params = {
          deviceId: this.currTreeData.equipId
        };
        PROJECTAPI.deleteProjectEquipmentInfo(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("删除成功！");
            // this.onSearch();
            const parent = node.parent;
            const children = parent.data.childList || parent.data;
            const index = children.findIndex(d => d.treeId === data.treeId);
            children.splice(index, 1);
            this.tableData = [];
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      },
      more(data) {
        if (this.moreData && data.treeId != this.moreData.treeId) {
          this.$set(this.moreData, 'show', false);
        }
        this.moreData = data;
        this.currTreeData = data;
        this.disabled = !this.disabled;
        this.$set(data, 'show', !data.show);
      },
      getMouseXY(e) {
        if (this.moreData) {
          this.$set(this.moreData, 'show', false);
          this.$set(this.moreData, 'isCopyBlock', false);
        }
      },
      choose(data) {
        this.chooseData = data;
        this.$refs.chooseDataDialog.open();
        this.productTypeList = [];
        this.searchProductList(0);
        setTimeout(() => {
          this.dom = this.$refs.multipleTable.bodyWrapper;
          this.dom.addEventListener('scroll', () => {
            // 滚动距离
            let scrollTop = this.dom.scrollTop + 2;
            // 变量windowHeight是可视区的高度
            let windowHeight = this.dom.clientHeight || this.dom.clientHeight;
            // 变量scrollHeight是滚动条的总高度
            let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight;
            if (scrollTop + windowHeight > scrollHeight) {
              this.$nextTick(() => {
                if (this.levelTableData.length < this.scrollTotal) {
                  this.scrollStart += 10;
                  this.end += 10;
                  this.searchDeviceLibrary();
                }
              })
            }
          })
        }, 2000)
      },
      onChooseSearch() {
        if (this.chooseDialogData.topProductTypeId == "" && this.chooseDialogData.productType == "" && this
          .chooseDialogData.searchKey == "") {
          this.$message.warning("请至少选择一个查询条件！");
        } else {
          let params = {
            start: 0,
            productTypeId: this.chooseDialogData.productType,
            searchKey: this.chooseDialogData.searchKey,
            end: 10,
            topProductTypeId: this.chooseDialogData.topProductTypeId,
            type: 1
          };
          EquipmentLibraryApi.searchDeviceLibrary(params).then(res => {
            if (res.data.code == 200) {
              this.levelTableData = res.data.data.dataList;
              this.scrollTotal = res.data.data.totalCount;
            }
          });
        }
      },
      onSelectionChange(val) {
        let bindDeviceLibraryIds = [];
        for (let i in val) {
          var htmlDoc = this.parseHTML(val[i].deviceCode);
          bindDeviceLibraryIds.push({
            deviceId: val[i].deviceId,
            deviceCode: htmlDoc.textContent + "_" + (Number(new Date().getTime()) + Number(i))
          });
        }
        this.bindDeviceLibraryIds = bindDeviceLibraryIds;
      },
      parseHTML(html) {
        var t = document.createElement('template');
        t.innerHTML = html;
        return t.content.cloneNode(true);
      },
      handleSelectionRows(selection) {
        this.selectionRows = selection;
      },
      saveEquipmentLibraryChoose() {
        let params = {
          deviceLibraryCopyDTOList: this.bindDeviceLibraryIds,
          deviceLibraryId: this.currTreeData.equipId == '' ? this.currTreeData.emsId : this.currTreeData.equipId,
          type: this.chooseData.type
        }
        PROJECTAPI.batchBindProjectEquipment(params).then(res => {
          if (res.data.code == 200) {
            this.$refs.chooseDataDialog.close();
            this.$message.success("操作成功！");
            this.onSearch();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      },
      copy(data) {
        this.$set(data, 'isCopyBlock', !data.isCopyBlock);
        this.copyDeviceCode = "";
        this.copyTreeData = data;
      },
      copyProjectEquipment() {
        let params = {
          equipId: this.copyTreeData.equipId,
          equipCode: this.copyDeviceCode
        };
        PROJECTAPI.copyProjectEquipment(params).then(res => {
          if (res.data.code == 200) {
            this.$set(this.copyTreeData, 'isCopyBlock', false);
            this.$message.success("复制成功！");
            this.onSearch();
          }
        });
      },
      leadingIn(node, data) {
        this.$refs.leadingInDialog.open();
      },
      beforeUpload(file) {
        const formdata = new FormData();
        formdata.append('files', file);
        formdata.append('projectId', this.projectId);
        formdata.append('emsId', this.currentSn);
        formdata.append('equipType', this.formExcel.equipType);
        // let self = this;
        // PROJECTAPI.importExcelsForProjectData(formdata)
        //   .then(res => {
        //     if (res.data.code == 200) {
        //       self.$message.success('操作成功');
        //       return true;
        //     }
        //   }).catch((e) => {
        //   })
        // return false;
      },
      handleRemove(file, fileList) {
      },
      handlePreview(file) {
      },
      closeLeadingInDialog() {
        this.$refs.leadingInDialog.close();
      },
      addDataPoint() {
        this.isTableEdit = false;
        this.dataPointConfigForm = {};
        this.$refs.dataPointConfigDialog.open();
      },
      confirmDataPointConfigData(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {};
            if (!this.isTableEdit) { //添加数据点
              this.dataPointConfigForm.equipId = this.currTreeData.equipId;
              params = this.dataPointConfigForm;
              PROJECTAPI.addProjectEquipmentFieldsInfoV2(params).then(res => {
                if (res.data.code == 200) {
                  this.$message.success("添加成功！");
                  this.$refs.dataPointConfigDialog.close();
                  this.searchProjectEquipFields(this.currTreeData);
                } else {
                  this.$message({
                    type: "error",
                    message: res.data.msg
                  });
                }
              });
            } else { // 修改数据点
              params = {
                authorization: this.dataPointConfigForm.authorization,
                // coefficient: this.dataPointConfigForm.coefficient,
                content: this.dataPointConfigForm.content,
                dataType: this.dataPointConfigForm.dataType,
                dataTypeId: this.dataPointConfigForm.dataTypeId,
                // defaultValue: this.dataPointConfigForm.defaultValue,
                emsId: this.dataPointConfigForm.emsId,
                equipId: this.dataPointConfigForm.equipId,
                // fieldDescribe: this.dataPointConfigForm.fieldDescribe,
                fields: this.dataPointConfigForm.fields,
                fieldsId: this.dataPointConfigForm.fieldsId,
                projectId: this.dataPointConfigForm.projectId,
                // range: this.dataPointConfigForm.range,
                unit: this.dataPointConfigForm.unit
              };
              PROJECTAPI.updateProjectEquipmentFieldInfoV2(params).then(res => {
                if (res.data.code == 200) {
                  this.$message.success("修改成功！");
                  this.$refs.dataPointConfigDialog.close();
                  this.searchProjectEquipFields(this.currTreeData);
                } else {
                  this.$message({
                    type: "error",
                    message: res.data.msg
                  });
                }
              });
            }
          }
        })
      },
      onEdit(row) {
        this.getProjectEquipmentFieldInfo(row);
        // for (let i in this.dataTypeIdList) {
        //   if (row.dataTypeId == this.dataTypeIdList[i].name) {
        //     row.dataTypeId = this.dataTypeIdList[i].id;
        //   }
        // }
        // for (let j in this.dataTypeList) {
        //   if (row.dataType == this.dataTypeList[j].name) {
        //     row.dataType = this.dataTypeList[j].id;
        //   }
        // }
        this.isTableEdit = true;
        // this.dataPointConfigForm = row;
        this.$refs.dataPointConfigDialog.open();
      },
      getProjectEquipmentFieldInfo(row) {
        let params = {
          fieldId: row.fieldsId
        }
        PROJECTAPI.getProjectEquipmentFieldInfo(params).then(res => {
          if (res.data.code == 200) {
            this.dataPointConfigForm = res.data.data;
          }
        });
      },
      handleSelectionChange(val) {
        this.selectRows = val;
      },
      onDelete(row) {
        let self = this;
        this.$confirm('确定要删除吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            let fieldIds = [];
            fieldIds.push(row.fieldsId);
            self.deleteProjectEquipmentFieldsInfo(fieldIds.toString());
          })
          .catch(() => {});
      },
      //批量删除
      batchDelete() {
        let self = this;
        this.$confirm('确定要删除这些吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            let fieldIds = [];
            for (let i in self.selectRows) {
              fieldIds.push(self.selectRows[i].fieldsId);
            }
            self.deleteProjectEquipmentFieldsInfo(fieldIds);
          })
          .catch(() => {});
      },
      deleteProjectEquipmentFieldsInfo(id) {
        let params = {
          fieldIds: id
        };
        PROJECTAPI.deleteProjectEquipmentFieldsInfo(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("删除成功！");
            this.searchProjectEquipFields(this.currTreeData);
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      },
      beforeUploadEms(file) {
        const formdata = new FormData();
        formdata.append('multipartFile', file);
        formdata.append('projectId', this.projectId);
        let self = this;
        PROJECTAPI.importEmsExcel(formdata)
          .then(res => {
            if (res.data.code == 200) {
              self.$message.success('操作成功');
              self.onSearch();
              return true;
            }
          }).catch((e) => {
            console.log(e)
          })
        return false;
      },
    }
  };
</script>

<style lang="scss" scoped>
  .deviceConfig {
    width: 100%;
    height: 100%;
    padding-bottom: 10px;

    .content {
      padding: 20px 0px;
    }

    .leftTree {
      float: left;
      border-right: 1px solid;
      width: 400px;
      height: 58vh;
      padding-right: 20px;

      .filter-tree {
        height: 88%;
        margin-top: 20px;
        overflow: auto;
      }

      .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        overflow-x: auto;
        padding-right: 25px;

        &::-webkit-scrollbar {
          height: 5px;
        }
      }

      >>>.el-tree-node__content {
        height: 35px;
        line-height: 25px;
      }
    }

    .rightTable {
      float: left;
      width: calc(100% - 400px);
      padding: 10px 0px 10px 20px;
    }

    .btn {
      padding: 0px;
      font-size: 12px !important;

      &span {
        font-size: 12px !important;
      }
    }

    button.el-button.btn.el-button--text.el-button--mini {
      margin-left: 5px !important;
    }

    >>>.el-input-group__prepend {
      width: 100px;
      background: linear-gradient(135deg, #3897C1 0%, #1D7197 100%);
      color: #fff;
      font-family: PingFang;
      font-weight: 600;
    }

    >>>.el-input-group__append {
      width: 40px;
      background: linear-gradient(135deg, #0561E3 0%, #0049AD 100%);
      border-radius: 0px 4px 4px 0px;
      color: #fff;
    }

    >>>.el-input-group>.el-input__inner {
      border: 1px solid #E7E8EB;
      border: 1px 0px;
      border-radius: 0px !important;
    }

    .keywordClass {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }

    .filterType {
      >>>.el-icon-arrow-up:before {
        color: #fff;
      }

      >>>.el-input__inner {
        background: #FFFFFF linear-gradient(135deg, #3897C1 0%, #1D7197 100%) !important;
        border: 0px !important;
        border-radius: 4px 0px 0px 4px !important;
        box-shadow: 0px 4px 17px 0px rgba(187, 187, 187, 0.5);
        color: #fff;
      }
    }

    .searchKeyClass {
      >>>.el-input__inner {
        border-radius: 0px 4px 4px 0px !important;
      }

      >>>.el-select .el-input__inner:focus,
      >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #f3f4f5;
      }
    }

    #sector {
      position: absolute;
    }

    #sector .moreIcon {
      margin-left: 5px;
    }

    #sector ul {
      width: 12px;
      position: relative;
      z-index: 99;
    }

    #sector ul li {
      list-style: none;
      position: absolute;
      background: #ccc;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      left: -18px;
      top: -42px;
      display: flex;
      justify-content: center;
      align-items: center;
      -webkit-transform-origin: 100% 100%;
      -moz-transform-origin: 100% 100%;
      -ms-transform-origin: 100% 100%;
      transform-origin: 100% 100%;
    }

    #sector .sector1 {
      margin-top: -25px;
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);

      img:hover {
        transform: scale(1.5);
      }
    }

    #sector .sector2 {
      margin-top: -15px;
      margin-left: 2px;
      // -webkit-transform: rotate(-30deg);
      // -moz-transform: rotate(-30deg);
      // -ms-transform: rotate(-30deg);
      // transform: rotate(-30deg);

      img:hover {
        transform: scale(1.5);
      }
    }

    #sector .sector3 {
      margin-top: 0px;
      margin-left: -12px;
      // -webkit-transform: rotate(-60deg);
      // -moz-transform: rotate(-60deg);
      // -ms-transform: rotate(-60deg);
      // transform: rotate(-60deg);

      img:hover {
        transform: scale(1.5);
      }
    }

    #sector .sector4 {
      margin-top: 20px;
      margin-left: -20px;
      // -webkit-transform: rotate(-90deg);
      // -moz-transform: rotate(-90deg);
      // -ms-transform: rotate(-90deg);
      // transform: rotate(-90deg);

      img:hover {
        transform: scale(1.5);
      }
    }

    #sector .sector5 {
      margin-top: 40px;
      margin-left: -12px;
      // -webkit-transform: rotate(-120deg);
      // -moz-transform: rotate(-120deg);
      // -ms-transform: rotate(-120deg);
      // transform: rotate(-120deg);

      img:hover {
        transform: scale(1.5);
      }
    }

    #sector .sector6 {
      margin-top: 56px;
      margin-left: 1px;
      // -webkit-transform: rotate(-150deg);
      // -moz-transform: rotate(-150deg);
      // -ms-transform: rotate(-150deg);
      // transform: rotate(-150deg);

      img:hover {
        transform: scale(1.5);
      }
    }

    #sector .sector7 {
      margin-top: 66px;
      margin-left: 20px;
      // -webkit-transform: rotate(270deg);
      // -moz-transform: rotate(270deg);
      // -ms-transform: rotate(270deg);
      // transform: rotate(270deg);

      img:hover {
        transform: scale(1.5);
      }
    }

    #sector ul li p {
      position: absolute;
      top: 73px;
      left: 120px;
    }

    .copyBlock {
      background: #ccc;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      margin-left: -8%;
      margin-top: 50px;
      padding: 5px 10px;
      position: absolute;
      z-index: 99;
    }

    >>>.el-loading-mask {
      height: 72vh;
    }
  }
</style>
<style lang="scss">
  .el-select-dropdown.el-popper.filterTypePopper {
    background: #FFFFFF linear-gradient(135deg, #3897C1 0%, #1D7197 100%) !important;
    box-shadow: 0px 4px 17px 0px rgba(187, 187, 187, 0.5);
  }

  .filterTypePopper .el-select-dropdown__item {
    color: #fff;
  }

  .filterTypePopper .el-select-dropdown__item.selected {
    background: #fff;
    color: #2E81B1;
  }

  .filterTypePopper .el-select-dropdown__item.hover {
    background: #1D7197;
    color: #fff;
  }

  .filterTypePopper .popper__arrow {
    display: none !important;
  }

  button.el-button.moreBtn.el-button--text.el-button--small {
    color: #000;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    margin-left: 20px !important;
    margin-top: 10px !important;
  }

  button.el-button.moreBtn.el-button--text.el-button--small.is-disabled {
    color: #C0C4CC;
  }

  button.el-button.searchIcon.el-button--default.el-button--medium {
    background: linear-gradient(135deg, #0561E3 0%, #0049AD 100%);
    color: #fff;
  }

  .deviceConfig .el-tooltip {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/project/deviceConfig.vue